import { Component, OnInit, ViewChild } from '@angular/core'
import * as moment from 'moment'
import { ReportsGateway } from '../../gatewasys/reports.gateway'
import { SearchModel } from '../../models/enrollment-search-details'
import { Router } from '@angular/router'
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid'
import { PortalGlobals } from '../../../portalglobals'
import { MedicareIDSearch } from '../../models/MedicareIDSearch'

@Component({
    selector: 'MedicareIDSearch',
    templateUrl: 'medicareid-search.component.html'
})
export class MedicareIDSearchComponent implements OnInit {
    public loading = false
    FmoModel: SearchModel
    ListValueId: string
    MedicareID: string
    medicareSearch: MedicareIDSearch[] = []
    @ViewChild('gridReference', { static: true }) myGrid: jqxGridComponent
    source: any = {
        dataFields: [
            { name: 'ApplicantFirstName', type: 'string' },
            { name: 'ApplicantLastName', type: 'string' },
            { name: 'SubscriberID', type: 'string' },
            { name: 'ApplicantHICN', type: 'string' },
            { name: 'Description', type: 'string' },
            { name: 'DateOfEnrollment', type: 'string' },
            { name: 'CoverageEffectiveDate', type: 'string' },
            { name: 'TierTranslation', type: 'string' }
        ],
        dataType: 'json',
        localData: this.medicareSearch
    }

    dataAdapter: any = new jqx.dataAdapter(this.source)
    columns: any[] = [
        { text: 'Applicant First Name', dataField: 'ApplicantFirstName', width: 200 },
        { text: 'Applicant Last Name', dataField: 'ApplicantLastName', width: 200 },
        { text: 'GID', dataField: 'SubscriberID', width: 115 },
        { text: 'Status', dataField: 'Description', width: 140 },
        { text: 'Medicare Number', dataField: 'ApplicantHICN', width: 155 },
        { text: 'Application Date', dataField: 'DateOfEnrollment', width: 165 },
        { text: 'Effective Date', dataField: 'CoverageEffectiveDate', width: 165 },
        { text: 'Plan', dataField: 'TierTranslation', width: 100 }
    ]

    constructor(private _routers: Router, private _reportsGateway: ReportsGateway, private _globals: PortalGlobals) {}

    ngOnInit() {
        this.FmoModel = {} as SearchModel
        let today = new Date()
        var year = 2018 //this._global.selectedPlanYear;
        var month = 1
        var day = 10
        this.FmoModel.StartDate = moment().date(day).month(month).year(year).subtract('years', 1).format('M/D/YYYY')
        // this.FmoModel.StartDate = moment('10 / 1 / 2018').subtract('years',1).toDate();
        this.FmoModel.EndDate = moment(today).format('M/D/YYYY')
    }

    getMedicareSearchList(FmoModel) {
        this.loading = true
        this._reportsGateway.getMedicareSearchData(FmoModel.searchText).subscribe(
            (data) => {
                this.medicareSearch = data
                this.source.localdata = this.medicareSearch
                this.dataAdapter.dataBind()
                this.myGrid.updatebounddata()
                this.loading = false
            },
            (error) => {
                this.source.localdata = null
                this.dataAdapter.dataBind()
                this.myGrid.updatebounddata()
                this.loading = false
            }
        )
    }

    onBack() {
        const insCo = this._globals.currentUser.insuranceCompanyShortName.toLowerCase()
        this._routers.navigateByUrl('/' + insCo + '/reports/my-clients/counts')
    }

    searchByMedicare(): void {
        if (this.FmoModel.searchText != null && this.FmoModel.searchText != undefined) {
            this.getMedicareSearchList(this.FmoModel)
        }
    }

    onKeyDown(event) {
        const ENTER_KEY = 13
        if (event.keyCode === ENTER_KEY) {
            this.searchByMedicare()
        }
    }
}
